<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <path
            d="M23.9999 2.5C12.1149 2.513 2.48994 12.158 2.50294 24.043C2.50684 27.6495 3.41705 31.1971 5.14994 34.36L3.49994 44.5L13.6399 42.85C24.0499 48.56 37.1199 44.751 42.8299 34.34C48.5399 23.929 44.7319 10.861 34.3209 5.15C31.1578 3.41477 27.6078 2.50346 23.9999 2.5Z"
            :stroke="color"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M25.5441 24C26.8038 24 28.012 24.5004 28.9028 25.3912C29.7936 26.282 30.2941 27.4902 30.2941 28.75C30.2941 30.0098 29.7936 31.218 28.9028 32.1088C28.012 32.9996 26.8038 33.5 25.5441 33.5H17.7061V14.5H25.5441C26.8038 14.5 28.012 15.0004 28.9028 15.8912C29.7936 16.782 30.2941 17.9902 30.2941 19.25C30.2941 20.5098 29.7936 21.718 28.9028 22.6088C28.012 23.4996 26.8038 24 25.5441 24ZM25.5441 24H17.7061"
            :stroke="color"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
<script>
export default {
    name: "WhatsappBusinessIcon",
    props: {
        color: {
            type: String,
            default: "#ffffff",
        },
        className: {
            type: String,
            default: "",
        },
    },
};
</script>
